module.exports = __webpack_public_path__ + "img/house.54632046.svg";